import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "附属明細表出力（医療法人会計基準）", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "出力", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_loading_button, {
        color: "primary",
        onClick: _ctx.onClickedExport,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_dismissible_alert, {
        class: "mt-3",
        color: "danger",
        message: _ctx.errorMessage,
        onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = null))
      }, null, 8, ["message"])
    ]),
    _: 1
  }))
}